import { i } from 'vite/dist/node/chunks/moduleRunnerTransport';
import { Measurement } from '../../components/measurement';
import { VisionWindowManager } from '../../window/manager';
import { VisionWindow } from '../../window/window';
import { PreventativeMaintenanceTab } from './pm';
import { PMType, PMTypeDTO } from './pmservice';

export class PMTypeWindow extends VisionWindow {
    layout!: dhtmlXLayoutObject;
    typeGrid!: dhtmlXGridObject;
    toolbar!: dhtmlXToolbarObject;
    form!: dhtmlXForm;
    selectedPMType: PMTypeDTO | undefined;
    tab: PreventativeMaintenanceTab;
    cache!: Map<string, PMTypeDTO>;
    notificationToolbar!: dhtmlXToolbarObject;
    notificationGrid!: dhtmlXGridObject;

    formGrid!: dhtmlXGridObject;

    constructor(manager: VisionWindowManager, tab: PreventativeMaintenanceTab) {
        const height = window.innerHeight * 0.75;
        const width = window.innerWidth * 0.85;
        super(manager, {
            id: 'type_pm_window',
            title: 'PM Types',
            x: 30,
            y: 30,
            width: width,
            height: height,
        });
        this.window.setText('PM Types');
        this.tab = tab;
        this.cache = new Map<string, PMTypeDTO>();

        this.layout = this.window.attachLayout('3L');
        this.layout.cells('a').hideHeader();
        this.layout.cells('b').hideHeader();
        this.layout.cells('c').hideArrow();
        this.layout.cells('c').setText('Notifications');
        this.layout.cells('b').setHeight(height * 0.45);
        this.notificationToolbar = this.layout.cells('c').attachToolbar();
        this.notificationToolbar.addButton('new', 1, 'Add', 'css/imgs/new.gif', '');
        this.notificationGrid = this.layout.cells('c').attachGrid();
        this.notificationGrid.setHeader('Email,Remove', '', ['text-align:center;', 'text-align:center;']);
        this.notificationGrid.setColAlign('left,right');
        this.notificationGrid.setColTypes('ed,img');
        this.notificationGrid.setInitWidths('*,64');
        this.notificationGrid.init();

        const totalWidth = this.layout.cells('a').getWidth() + this.layout.cells('b').getWidth();
        const newA = Math.round(totalWidth * 0.25);
        const newB = totalWidth - newA;

        this.layout.cells('a').setWidth(newA);
        this.layout.cells('b').setWidth(newB);

        this.selectedPMType = undefined;

        const formData = [
            { type: 'settings', position: 'label-left', labelWidth: 120, inputWidth: 120, labelAlign: 'left', offsetLeft: '25' },
            { name: 'id', type: 'input', label: 'ID', value: '', labelAlign: 'left', disabled: true },
            { name: 'name', type: 'input', label: 'Name', value: 'New PM', labelAlign: 'left', disabled: false },
            { type: 'container', name: 'grid_container', inputHeight: 500, inputWidth: newB * 0.75 },
        ];

        this.toolbar = this.layout.cells('b').attachToolbar();
        this.toolbar.addButton('new', 0, 'New', 'icons/sign.png', '');
        this.toolbar.addButton('save', 1, 'Save', 'css/imgs/save.gif', '');
        this.toolbar.addButton('delete', 2, 'Delete', 'icons/clear.png', '');

        this.layout.setSizes();
        this.form = this.layout.cells('b').attachForm(formData);

        this.formGrid = new dhtmlXGridObject(this.form.getContainer('grid_container'));
        this.formGrid.setHeader('Enable,Type,Interval,Alert At,,Month,Day', '', [
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
        ]);
        this.formGrid.setColAlign('center,center,center,center,center,center,center');
        this.formGrid.setColTypes('ch,ro,edn,edn,ro,co,co');
        this.formGrid.setInitWidths('75,*,*,*,*,100,100');
        this.formGrid.init();

        this.formGrid.addRow('calendar', [0, 'Calendar (months)', '', '', 'days left', '', ''], 0, 0, '', false);
        this.formGrid.addRow('days', [0, 'Days', '', '', 'days left', '', ''], 0, 0, '', false);
        this.formGrid.addRow('hours', [0, 'Hours', '', '', 'hours left', '', ''], 0, 0, '', false);
        this.formGrid.addRow('odometer', [0, 'Miles', '', '', 'miles left', '', ''], 0, 0, '', false);
        this.formGrid.setHighlight(false);

        this.formGrid.cells('odometer', 5).setDisabled(true);
        this.formGrid.cells('odometer', 6).setDisabled(true);

        const combo = this.formGrid.getCombo(5); // column index (0-based)
        const daycombo = this.formGrid.getCombo(6); // column index (0-based)

        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        months.forEach((name, i) => {
            combo.put(i + 1, name); // value = 1–12, label = month name
        });

        for (let day = 1; day <= 31; day++) {
            daycombo.put(day, String(day)); // value = day number, label = day number
        }

        this.typeGrid = this.layout.cells('a').attachGrid();
        this.typeGrid.setHeader('PM Name', '', ['text-align:center;']);
        this.typeGrid.setColAlign('left');
        this.typeGrid.setEditable(false);
        this.typeGrid.setColSorting('str');
        this.typeGrid.init();

        this.setupEvents();
        this.loadTypes(false);
    }

    private setupEvents(): void {
        this.toolbar.attachEvent('onClick', (id) => {
            this.toolbarHandler(id);
        });

        this.notificationToolbar.attachEvent('onClick', (_id) => {
            const rid = crypto.randomUUID();
            this.notificationGrid.addRow(rid, ',icons/clear.png', '', '', '', false);
        });

        this.typeGrid.attachEvent('onRowSelect', (rid, _cid) => {
            this.rowSelected(rid);
        });

        this.notificationGrid.attachEvent('onRowSelect', (rid, cid) => {
            if (cid == 1) {
                this.notificationGrid.deleteRow(rid);
            }
        });
    }

    /** Get the PM types and build the grid.
     * @param refresh True if should clear/reload the cache
     */
    private loadTypes(refresh: boolean): void {
        const request = this.tab.service.getTypes(refresh);

        if (refresh == true) {
            this.typeGrid.clearAll(false);
            this.cache.clear();
        }

        request.then((data) => {
            data.forEach((pmtype) => {
                const row = [];
                row.push(pmtype.name);
                this.typeGrid.addRow(pmtype.id, row.join(','), 0, 0, '', false);
                this.cache.set(pmtype.id, pmtype);
            });
            this.typeGrid.adjustColumnSize(0);
        });
    }

    private clearGrid(): void {
        this.formGrid.cells('odometer', 0).setValue('0');
        this.formGrid.cells('hours', 0).setValue('0');
        this.formGrid.cells('calendar', 0).setValue('0');
        this.formGrid.cells('days', 0).setValue('0');
        this.formGrid.cells('odometer', 2).setValue('');
        this.formGrid.cells('odometer', 3).setValue('');
        this.formGrid.cells('hours', 2).setValue('');
        this.formGrid.cells('hours', 3).setValue('');
        this.formGrid.cells('calendar', 2).setValue('');
        this.formGrid.cells('calendar', 3).setValue('');
        this.formGrid.cells('days', 2).setValue('');
        this.formGrid.cells('days', 3).setValue('');
        this.formGrid.cells('calendar', 5).setValue('1');
        this.formGrid.cells('calendar', 6).setValue('1');
    }

    private rowSelected(id: string): void {
        const pmtype = this.cache.get(id);
        this.selectedPMType = pmtype;

        this.form.setItemValue('name', pmtype?.name);
        this.form.setItemValue('id', pmtype?.id);
        this.notificationGrid.clearAll(false);
        this.clearGrid();

        if (pmtype?.odometerIntervalKm != undefined) {
            this.formGrid.cells('odometer', 0).setValue('1');
            this.formGrid.cells('odometer', 2).setValue(Measurement.km2miles(pmtype.odometerIntervalKm).toFixed(1));
            this.formGrid.cells('odometer', 3).setValue(Measurement.km2miles(pmtype.odometerAlertKm).toFixed(1));
        }
        if (pmtype?.hoursInterval != undefined) {
            this.formGrid.cells('hours', 0).setValue('1');
            this.formGrid.cells('hours', 2).setValue(pmtype.hoursInterval.toString());
            this.formGrid.cells('hours', 3).setValue(pmtype.hoursAlert.toString());
        }
        if (pmtype?.daysInterval != undefined) {
            this.formGrid.cells('days', 0).setValue('1');
            this.formGrid.cells('days', 2).setValue(pmtype.daysInterval.toString());
            this.formGrid.cells('days', 3).setValue(pmtype.daysAlert.toString());
        }
        if (pmtype?.dateInterval != undefined) {
            this.formGrid.cells('calendar', 0).setValue('1');
            this.formGrid.cells('calendar', 2).setValue(pmtype.dateInterval.toString());
            this.formGrid.cells('calendar', 3).setValue(pmtype.dateAlert.toString());
            this.formGrid.cells('calendar', 5).setValue(pmtype.dateMonth.toString());
            this.formGrid.cells('calendar', 6).setValue(pmtype.dateDay.toString());
        }

        if (pmtype?.email != undefined) {
            pmtype.email.forEach((email) => {
                this.notificationGrid.addRow(crypto.randomUUID(), [email, 'icons/clear.png'], '', '', '', false);
            });
        }
    }

    private toolbarHandler(id: string) {
        switch (id) {
            case 'save': {
                this.savePMType();
                break;
            }
            case 'new': {
                this.clearForm();
                break;
            }
            case 'delete': {
                this.deleteType();
                break;
            }
        }
    }

    /** Deletes the current selected PM Type */
    private deleteType(): void {
        let id = 'none';
        if (this.selectedPMType) {
            id = this.selectedPMType.id;
        } else {
            return;
        }

        dhtmlx.confirm({
            type: 'confirm-warning',
            title: 'Delete PM Type',
            text: 'This will delete the PM type and any associated active and completed PMs',
            callback: (result: boolean) => {
                if (result == true) {
                    this.tab.service.deletePMType(id).then((data) => {
                        if (data.parsedBody) {
                            dhtmlx.message({
                                title: 'Complete',
                                text: 'PM Type was deleted',
                                type: 'alert-success',
                            });
                            // Refresh the page.
                            this.clearForm();
                            this.loadTypes(true);
                            this.tab.loadData(true);
                        }
                    });
                }
            },
        });
    }

    /** Clear the form for a new PM
     *
     */
    private clearForm(): void {
        this.typeGrid.clearSelection();
        this.selectedPMType = undefined;
        this.notificationGrid.clearAll(false);

        this.form.setItemValue('id', '');
        this.form.setItemValue('name', 'Enter PM Name');

        this.formGrid.cells('odometer', 0).setValue('0');
        this.formGrid.cells('hours', 0).setValue('0');
        this.formGrid.cells('calendar', 0).setValue('0');
        this.formGrid.cells('days', 0).setValue('0');

        this.formGrid.cells('odometer', 2).setValue('');
        this.formGrid.cells('odometer', 3).setValue('');
        this.formGrid.cells('hours', 2).setValue('');
        this.formGrid.cells('hours', 3).setValue('');
        this.formGrid.cells('calendar', 2).setValue('');
        this.formGrid.cells('calendar', 3).setValue('');
        this.formGrid.cells('days', 2).setValue('');
        this.formGrid.cells('days', 3).setValue('');
        this.formGrid.cells('calendar', 5).setValue('1');
        this.formGrid.cells('calendar', 6).setValue('1');
    }

    private savePMType() {
        const dto = {} as PMTypeDTO;
        if (this.selectedPMType != undefined) {
            dto.id = this.selectedPMType.id;
        }
        dto.name = this.form.getItemValue('name');
        dto.type = -1;

        const odometerEnabled = this.formGrid.cells('odometer', 0).isChecked();
        const hoursEnabled = this.formGrid.cells('hours', 0).isChecked();
        const calendarEnabled = this.formGrid.cells('calendar', 0).isChecked();
        const daysEnabled = this.formGrid.cells('days', 0).isChecked();

        if (odometerEnabled) {
            const valueInterval = this.formGrid.cells('odometer', 2).getValue() as string;
            const sanitizedInterval = valueInterval.toString().replace(/,/g, '');
            const interval = parseFloat(sanitizedInterval);
            const valueAlert = this.formGrid.cells('odometer', 3).getValue() as string;
            const sanitizedAlert = valueAlert.toString().replace(/,/g, '');
            const alert = parseFloat(sanitizedAlert);

            if (isNaN(interval) || isNaN(alert)) {
                dhtmlx.message({
                    title: 'Error',
                    text: 'Please enter valid numbers for the odometer interval and alert.',
                    type: 'alert-error',
                });
                return;
            }

            dto.odometerIntervalKm = Measurement.miles2km(interval);
            dto.odometerAlertKm = Measurement.miles2km(alert);
        }

        if (hoursEnabled) {
            const valueInterval = this.formGrid.cells('hours', 2).getValue() as string;
            const sanitizedInterval = valueInterval.toString().replace(/,/g, '');
            const interval = parseFloat(sanitizedInterval);
            const valueAlert = this.formGrid.cells('hours', 3).getValue() as string;
            const sanitizedAlert = valueAlert.toString().replace(/,/g, '');
            const alert = parseFloat(sanitizedAlert);

            if (isNaN(interval) || isNaN(alert)) {
                dhtmlx.message({
                    title: 'Error',
                    text: 'Please enter valid numbers for the hours interval and alert.',
                    type: 'alert-error',
                });
                return;
            }

            dto.hoursInterval = interval;
            dto.hoursAlert = alert;
        }

        if (daysEnabled) {
            const valueInterval = this.formGrid.cells('days', 2).getValue() as string;
            const sanitizedInterval = valueInterval.toString().replace(/,/g, '');
            const interval = parseFloat(sanitizedInterval);
            const valueAlert = this.formGrid.cells('days', 3).getValue() as string;
            const sanitizedAlert = valueAlert.toString().replace(/,/g, '');
            const alert = parseFloat(sanitizedAlert);

            if (isNaN(interval) || isNaN(alert)) {
                dhtmlx.message({
                    title: 'Error',
                    text: 'Please enter valid numbers for the days interval and alert.',
                    type: 'alert-error',
                });
                return;
            }

            dto.daysInterval = interval;
            dto.daysAlert = alert;
        }

        if (calendarEnabled) {
            const valueInterval = this.formGrid.cells('calendar', 2).getValue() as string;
            const sanitizedInterval = valueInterval.toString().replace(/,/g, '');
            const interval = parseFloat(sanitizedInterval);
            const valueAlert = this.formGrid.cells('calendar', 3).getValue() as string;
            const sanitizedAlert = valueAlert.toString().replace(/,/g, '');
            const alert = parseFloat(sanitizedAlert);

            if (isNaN(interval) || isNaN(alert)) {
                dhtmlx.message({
                    title: 'Error',
                    text: 'Please enter valid numbers for the calendar interval and alert.',
                    type: 'alert-error',
                });
                return;
            }

            dto.dateInterval = interval;
            dto.dateAlert = alert;

            dto.dateMonth = parseInt(this.formGrid.cells('calendar', 5).getValue() as string, 10);
            dto.dateDay = parseInt(this.formGrid.cells('calendar', 6).getValue() as string, 10);

            if (isNaN(dto.dateMonth) || isNaN(dto.dateDay)) {
                dhtmlx.message({
                    title: 'Error',
                    text: 'Please enter a valid month and day for the calendar interval.',
                    type: 'alert-error',
                });
                return;
            }
        }

        const emails: string[] = [];
        this.notificationGrid.forEachRow((rid) => {
            emails.push(this.notificationGrid.cells(rid, 0).getValue());
        });

        dto.email = emails;
        const request = this.tab.service.savePMType(dto);

        request.then((_data) => {
            //TODO: This should check response code for OK
            dhtmlx.message({
                title: 'Save Complete',
                text: 'PM Type was saved',
                type: 'alert-success',
            });

            this.loadTypes(true);
            this.clearForm();
        });
    }
}
